module.exports = __webpack_public_path__ + "img/kanta-icon.e575cd9a.svg";